module.exports = __webpack_public_path__ + "static/composer-install-1-30f7ea949644e3927a32e926a192ad58.png";